import { Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconMessageReportFilled, IconUser } from '@tabler/icons-react';
import React from 'react';
import cx from 'clsx';
import { useDisclosure } from '@mantine/hooks';

import { LOGOUT_URL, SUPPORT_PORTAL_HREF } from '@/constants';
import { getUserEmail } from '@/helpers';

import classes from './private-layout.module.css';

const PrivateLayoutUser: React.FC = () => {
  const [isOpen, { open, close }] = useDisclosure(false);

  return (
    <Menu
      width={200}
      position="bottom-end"
      transitionProps={{ transition: 'pop-top-right' }}
      onClose={close}
      onOpen={open}
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton
          ml="auto"
          className={cx(classes.targetButton, classes.user, { [classes.userActive]: isOpen })}>
          <Group gap={7}>
            <IconUser size="1.5rem" />
            <Text fw={500} size="sm" lh={1} mr={3}>
              {getUserEmail()}
            </Text>
            <IconChevronDown size={12} stroke={1.5} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          component="a"
          href={SUPPORT_PORTAL_HREF}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Group justify="flex-end">
            <IconMessageReportFilled size="1.5rem" />
            <Text>Support</Text>
          </Group>
        </Menu.Item>
        <Menu.Item
          component="a"
          href={LOGOUT_URL}
          ta="right"
        >
          Log Out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default PrivateLayoutUser;
